// <- TaskManagment.js
import React, { Fragment ,useState,useRef ,useEffect} from "react";
import {
  Button,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  Table,
  Row, 
  Col,
} from "reactstrap";

import Moment from 'moment';
import moment from "moment";
import "../../../style/tasks.css";

import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import { Overlay, Tooltip ,OverlayTrigger} from "react-bootstrap";

const loginUser = JSON.parse(localStorage.getItem("user"));


let allowedDates=[];
const TaskAction = ({ employeeName, activity, date}) => (
  <div className="task-information ">
    <span className="task-info-line">
      <span className="task-user">{employeeName}</span>
      <span className=" ml-2 task-info-subject ">{activity}</span>
      <div className="task-time">{String(date).substr(0, 16)}</div>
    </span>
  </div>
);

// chat message body.
const ChatBody = ({ employeeName, employeePicture, message  }) => (
  <Fragment>
    <div className="chat-body ">
      <div className="content">
        <div className="avatar">
          <img
            alt=""
            src={require(`../../../img/employee/${employeePicture}`)}
          />
        </div>
        <div className="message-body">
          <div className="chat-user">
            <span className="name">{employeeName}</span>
            <span className="ml-2 time text-muted">8:30 am</span>
          </div>
          <div className="chat-message text-muted">{message}</div>
        </div>
      </div>
    </div>
  </Fragment>
);

// Chat Footer.
const ChatFooter = () => (
  <div className="chat-footer" style={{display:'none'}}>
    <div className="message-bar">
      <div className="message-inner">
        <a className="link attach-icon" href="#">
          <i className="fa fa-paperclip"></i>
        </a>
        <div className="">
          <InputGroup>
            <Input placeholder="" />
            <InputGroupAddon addonType="append">
              <InputGroupText>
                <i className="fas fa-paper-plane"></i>
              </InputGroupText>
            </InputGroupAddon>
          </InputGroup>
        </div>
      </div>
    </div>
    <div className="p-1">
      <span className="mr-1">Members</span>
      <div className="avatar">
        <img alt="" src={require("../../../img/employee/avatar-01.jpg")} />
      </div>
      <div className="avatar">
        <img alt="" src={require("../../../img/employee/avatar-02.jpg")} />
      </div>
    </div>
  </div>
);
const DetailsOfTask = React.memo(({ selectedTask, handleAddEditTaskForm,unlockReqList,updatestatus,handlecloseDetailsList }) => {
  //console.log(selectedTask)
var Status = "New";
if(selectedTask!=null && selectedTask.timeSheetStatus!=null){
  if(selectedTask.timeSheetStatus == 2){
    Status = "In Progress";
  }
  else if(selectedTask.timeSheetStatus == 3){
    Status = "Completed";
  }
}
//----------------Enable Disable Edit Icon--------------------------
function getDatesInRange(startDate, endDate) {
  const date =new Date(startDate);
const enddate=new Date(endDate)
  const dates = [];

  while (date <= enddate) {
    dates.push(moment(new Date(date)).format("YYYY-MM-DD"));
    date.setDate(date.getDate() + 1);
  }

  return dates;
}
const elementRef = useRef(null);
const elementRefUp = useRef(null);
const elementRefDown = useRef(null);
let datearray=[];
let datearraylast=[];
// const t = new Date().getDate() + (6 - new Date().getDay() - 1) - 7;
var curr = new Date;  
const t =new Date(curr.setDate(curr.getDate() - curr.getDay()+1)).getDate();
    let lastFriday = new Date();
    let lastFridayl = new Date();
    lastFridayl.setDate(t);
     lastFriday.setDate(t);
   
    if(unlockReqList!=null && unlockReqList.length!=0 && unlockReqList[0]!=''){
      let fromDate = unlockReqList[0].fromDate;
      var daterange=[];
      unlockReqList.map(function(unlock){
        daterange=getDatesInRange(moment(unlock.fromDate).format("YYYY-MM-DD"), moment(unlock.toDate).format("YYYY-MM-DD"));
        daterange.map(function(range){
          datearray.push(range);
        })
      })
     
      
      datearraylast.push(moment(lastFriday).format("YYYY-MM-DD"));
      const dd=daterange;
      // var dateParts = fromDate.split("-");
      // var jsDate = new Date(dateParts[0], dateParts[1] - 1, dateParts[2].substr(0,2));
      // lastFriday = jsDate;
      // console.log("lastFriday",lastFriday)
      // console.log("fromDate",jsDate)
    }
    else
    {
      var curr = new Date;  
      let fromDate =new Date(curr.setDate(curr.getDate() - curr.getDay()+1));
      // let fromDate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
      let toDate =  new Date();
      toDate.setDate(toDate.getDate() + 7);;
      // var dateParts = fromDate.split("-");
      // var jsDate = new Date(dateParts[0], dateParts[1] - 1, dateParts[2].substr(0,2));
      // lastFriday = jsDate;
      let range= getDatesInRange(fromDate,toDate,lastFridayl);
      datearraylast.push(range);
      allowedDates=range;
    }
    var enableEdit = false;
    if(selectedTask!=null && selectedTask.workDate!=null){
      // datearray.map(function (dat){
        const seldate=moment(selectedTask.workDate).format("YYYY-MM-DD");
        const state=false;
        const greatercon=datearraylast.find((user) =>seldate  >= user);
        const dd=datearray.indexOf(seldate);
        const gg=dd;
        if (datearray.indexOf(seldate) === -1 && greatercon === undefined) {
          if(selectedTask.employeeTimeSheetStatuses.length >0 && selectedTask.timeSheetStatus !==3 )
          {
            enableEdit = true;
          }
          else{
            if(selectedTask.leaveStatus == true)
              {
                enableEdit = false;
              }
              else
              {
                enableEdit = true;
              }
            
          }
          
      } else {
        if(selectedTask.leaveStatus == true)
          {
            enableEdit = false;
          }
          else
          {
            enableEdit = true;
          }
        // enableEdit = true;
      }
      
      // })
    
  }
  const handlecloseDetails=() =>{
    handlecloseDetailsList();
  }


 
  
  useEffect(() => {
    const element = document.getElementById('topview');
    element.scrollIntoView();
    if (elementRefUp.current) {
      elementRefUp.current.style.display = 'inline-flex';
      elementRefDown.current.style.display = 'none';
    }
      if(elementRef.current !== null)
      {
       if(elementRef.current.style.display == 'none')
        {
          elementRef.current.style.display = 'block';
        }
          // elementRef.current.style.display = 'block';
       
      }

   
  });
  const [display,setdisplay] = useState(0);
  const showElement =React.useCallback(() => {
    if (elementRef.current.style.display === "none") {
      elementRef.current.style.display = 'block';
      elementRefUp.current.style.display='inline-flex';
      elementRefDown.current.style.display='none';
    }
    else
    {
      elementRef.current.style.display = 'none';
      elementRefUp.current.style.display='none';
      elementRefDown.current.style.display='inline-flex';
    }
  },[elementRef,elementRefDown,elementRefUp]);
  const chunkSize = 20;
  const breakStringIntoChunks = (str, chunkSize) => {
    const chunks = [];
    for (let i = 0; i < str.length; i += chunkSize) {
      chunks.push(str.substring(i, i + chunkSize));
    }
    return chunks;
  };
  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Leave dates cannot be edited, You can delete and add a new leave if needed..
    </Tooltip>
  );

/**************************************************************** */
  return (
    <Fragment>
      <div className="fixed-header" id="topview" style={{height:"50px"}}>
        <div>
        {selectedTask != null ? ( (selectedTask.leaveStatus == false ? (selectedTask.timeSheetStatus !== 3 ? (<Button size="sm" outline className="secondary" onClick={() =>updatestatus(selectedTask)}>
            <i className="fas fa-check"></i> Mark Completed
          </Button>) : (<Button size="sm" outline className="secondary" disabled>
            <i className="fas fa-check"  style={{color:"green"}}></i>Completed
          </Button>)) : (null)) ) : (<Button size="sm" outline className="secondary" onClick={() =>updatestatus(selectedTask)}>
            <i className="fas fa-check"></i> Mark Completed
          </Button>) }  
          {/* {(loginUser !== null &&
              loginUser.RoleName === "Admin") ? null : (selectedTask!= null ? (selectedTask.timeSheetStatus !== 3 ? (<div className="d-inline float-right " style={selectedTask.leaveStatus == true ? ({display :'none'}) :({display :'block'})}>
              <Button color="" onClick={() => handleAddEditTaskForm("edit")} 
              style={enableEdit? {display:"block"}:{display:"none"}}
              >
                <i className="fas fa-edit text-muted"></i>
              </Button>
            </div>) :(<div className="d-inline float-right " style={selectedTask.leaveStatus === true ? ({display :'none'}) :({display :'block'})}>
              <Button color="" onClick={() => handleAddEditTaskForm("edit")}
              disabled 
            
              >
                <i className="fas fa-edit text-muted"></i>
              </Button>
            </div>) ):null )} */}
             {(loginUser !== null &&
              loginUser.RoleName === "Admin") ? null :selectedTask != null ? (selectedTask.leaveStatus === true ? (<div className="d-inline float-right ">
                <OverlayTrigger
        placement="left" // position the tooltip (top, right, bottom, left)
        delay={{ show: 250, hide: 400 }} // delay for showing and hiding
        overlay={renderTooltip}
      >
                <Button color="" onClick={() => handleAddEditTaskForm("edit")} 
                disabled
                >
                  <i className="fas fa-edit text-muted"></i>
                </Button>
                </OverlayTrigger>
              </div>) : (<div className="d-inline float-right ">
              <Button color="" onClick={() => handleAddEditTaskForm("edit")} 
              
              >
                <i className="fas fa-edit text-muted"></i>
              </Button>
            </div>) ) : null}
            <div className="d-inline float-right ">
                <Button color="" onClick={() =>handlecloseDetails()}>
                  <i className="fas fa-times text-muted"></i>
                </Button>
              </div>
        </div>
        
      </div>
      {selectedTask ? (
        <div className="task-details ">
          <div className="chat-wrap-inner">
            <div className="chats ">
              <span style={{display:"inline-flex"}}>
                <label>Project Name : </label> &nbsp;&nbsp;
                <label style={{fontWeight:"600"}}>{selectedTask.projectName}</label>
              </span>
              
              <h4 style={{fontWeight:"600"}}>{selectedTask.issueTitle}</h4>
              <div className="task-header ">
              
                <div className="task-due-date">
                  <div className="due-icon">
                    <span>
                      <i className="fas fa-calendar-alt text-muted"></i>
                    </span>
                  </div>
                  <div className="due-info">
                  {selectedTask.leaveStatus === true ?( <div className="task-head-title" style={{fontWeight:"600"}}>Leave On</div>):( <div className="task-head-title" style={{fontWeight:"600"}}>Created Date</div>)}

                    <div className="due-date" style={{fontWeight:"500"}}>{ Moment(selectedTask.workDate).format("DD MMM YYYY")}</div>
                  </div>
                </div>
                <div className="task-due-date" style={selectedTask.leaveStatus === true ? ({display :'none'}) : ({display :'flex'})}>
                  <div className="due-icon">
                    <span>
                      <i className="fas fa-calendar-alt text-muted"></i>
                    </span>
                  </div>
                  <div className="due-info" >
                  <div className="task-head-title" style={{fontWeight:"600"}}>Due Date</div>
                   
                    <div className="due-date" style={{fontWeight:"500"}}>{ Moment(selectedTask.dueDate).format("DD MMM YYYY")}</div>
                  </div>
                </div>
              </div>
              <hr></hr>
              <tr className=" txttask ultask">
                    <td style={selectedTask.leaveStatus === true ? ({paddingRight:"40px",display :'none'}) :({paddingRight:"40px",display :'block'})} >
                    <div className="title" style={{fontWeight:"600",fontSize:"14px"}}>Total Estimated Hours</div>
                    <div className="text ">{selectedTask.estimatedHour} hr</div>
                    </td>
                    <td style={{paddingRight:"40px"}}>
                    <div className="title" style={{fontWeight:"600",fontSize:"14px"}}>Total Hours Spent</div>
                    <div className="text">{selectedTask.hoursSpent} hr</div>
                    </td>
                    <td style={selectedTask.leaveStatus === true ? ({paddingRight:"40px",display :'none'}) :({paddingRight:"40px",display :'block'})} >
                    <div className="title" style={{fontWeight:"600",fontSize:"14px"}}>Total Hours Billable </div>
                    <div className="text ">{selectedTask.hoursBillable} hr</div>
                    </td>
                    <td style={selectedTask.leaveStatus === true ? ({paddingRight:"40px",display :'none'}) :({paddingRight:"40px",display :''})}>
                    <div className="title status" style={{fontWeight:"600",fontSize:"14px"}}>Status </div>
                    <div className="text">{Status}</div>
                    </td>
                  </tr>
                 



              <div className="task-data ">
                {/* <ul className="personal-info">
                  <li>
                  <div className="title">Start Time</div>
                    <div>{(selectedTask.startTime !== undefined && selectedTask.startTime !== null) ? (selectedTask.startTime.split(' ')[1] === "00:00:00" ? "0:00" : new Date(selectedTask.startTime).toLocaleString('en-IN',{ dateStyle: 'short', timeStyle: 'short' }).split(' ')[1])  : "0:00"}</div>
                  </li>
                  <li>
                    <div className="title">Estimated Hours</div>
                    <div className="text ">{selectedTask.estimatedHour} hr</div>
                  </li>
                 <br/>
                  <li>
                    <div className="title">Hours Spent</div>
                    <div className="text">{selectedTask.hoursSpent} hr</div>
                  </li>
                  <li>
                    <div className="title">Hours Billable </div>
                    <div className="text ">{selectedTask.hoursBillable} hr</div>
                  </li>
                  <li>
                    <div className="title status">Status </div>
                    <div className="text">{Status}</div>
                  </li>
                  <li style={{display : selectedTask.leaveStatus? "block" : "none"}}>
                    <div className="title status">Leave Type </div>
                    <div className="text">{selectedTask.leaveType == 1 ? "Half Day" : "Full Day"}</div>
                  </li>
                </ul> */}
                <br/>
                <div className="mb-1" style={{padding:3}}>
                  <span className="description-title " ><h4 style={{fontWeight:"600"}}>Description</h4></span>
                  <div>
                  <span className="description descriptionnew">
                   <h6>{selectedTask.description}</h6> 
                  </span>
                  </div>
                                   
                </div>
              
                {(selectedTask.employeeTimeSheetStatuses.length > 0 ) ?(
                  <div>
                       {/* <button onClick={showElement}>Show</button> */}
                    
                       <a onClick={showElement} style={{cursor: "pointer"}}><h4>Time Logging Details &nbsp;
                  <i class="fa fa-arrow-up" ref={elementRefUp} onClick={showElement}></i>
                  <i class="fa fa-arrow-down" ref={elementRefDown} onClick={showElement} ></i>
                       
                       </h4>
                       </a>
                     
                       
                    {/* <a href="#/" id="show"><h4>Time Logging Details</h4></a>
                    <a href="#hide" id="hide"><h4>Time Logging Details</h4></a> */}
                  {/* <h4>Time Logging Details</h4>  */}
                  {/* <div id="answer"> */}
                  <div ref={elementRef} >
                  <div style={{width :"750px" , height:"600px" ,overflow:"auto"}}>
                    <Table>
                  <thead className="performance-table">
                      <tr>
                          <th style={{textAlign:"left",width:"100px"}}>Start Date</th>
                          <th style={{textAlign:"left",width:"100px"}}>Hours Spent</th>
                          <th style={{textAlign:"left",width:"109px"}}>Hours Billable</th>                  
                          <th style={{textAlign:"left",width:"20px"}}>Status</th>
                          <th style={{textAlign:"left",width:"128px"}}>Approved Status</th>
                          <th style={{textAlign:"left"}}>Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      
                      {selectedTask.employeeTimeSheetStatuses.map((employee) =>
                        <tr> 
                        
                        <td>{moment(employee.statusDate).format("DD-MM-YYYY")}</td>
                        <td>{employee.hoursLogged}</td>
                        <td>{employee.hoursBillable}
                                               </td>
                        <td>{employee.status === 1 ? "New" :(employee.status === 2 ? "InProgress" : "Completed")}</td>
                        <td style={employee.isStatusUpdated === null ?({color:"Grey"}) : (employee.approvedStatus == true ? ({color:"Green"}) : ({color:"Red"}))}>{employee.isStatusUpdated === null ? "Pending" : (employee.approvedStatus == true ? "Approved" : "Rejected" )} 
                        {employee.isStatusUpdated === null ? "" : (employee.approvedStatus == false ? (<div>
                <Popup trigger=
                {<button class=" buttoninfo"> Reason</button>}
                position="right center">
                <div>{employee.reason}</div>
                
            </Popup>
        
                </div>) : (null))}
                          {/* <Input type="button">Details</Input> */}
                          </td>
                        <td>
                        {breakStringIntoChunks(employee.description, chunkSize).map((chunk, chunkIndex) => (
                <div key={chunkIndex}>{chunk}</div>
              ))}
                    </td>
                       
                       </tr>
                      )}
                       
                      
                    </tbody>
                  </Table>
                  </div>
                  </div>
                </div>
                ) : null}
                
              </div>
              <hr></hr>
            </div>
            <div className="task-activity" style={{display: 'none'}}>
              <TaskAction
                employeeName={"Jerry Malikakal"}
                activity={"Created Task"}
                date={new Date()}
              ></TaskAction>
              <TaskAction
                employeeName={"Waston Don"}
                activity={"Assign to Jerry "}
                date={new Date()}
              ></TaskAction>

              <ChatBody
                employeeName={"Jerry Malikakal"}
                employeePicture={"avatar-06.png"}
                message={
                  "hello, please help to solve db inertion of image. got stuck with JPF and PNG file import."
                }
              ></ChatBody>
              <ChatBody
                employeeName={"Waston"}
                employeePicture={"avatar-01.jpg"}
                message={"hi jerry, please update yesterday status."}
              ></ChatBody>
            </div>
          </div>
          <ChatFooter></ChatFooter>
        </div>
      ) : (
        "No Task"
      )}
    </Fragment>
  );
});

export default DetailsOfTask;
